import angular from 'angular';
import '../core.module';

export const STORAGE_KEYS = {
  AUTH_TOKEN: 'cp_auth_token',
  REFRESH_TOKEN: 'cp_refresh_token',
  TENANT_SLUG: 'cp_tenant_slug',
  CURRENT_USER: 'cp_current_user',
  THEME: 'cp_theme',
  SIDEBAR_COLLAPSED: 'cp_sidebar_collapsed',
  GUIDES: 'cp_guides',
  COMMAND_RECENTS: 'cp_command_recents'
};

angular.module('app.core').constant('STORAGE_KEYS', STORAGE_KEYS);
